import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import type { RouteProps } from 'react-router-dom';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import Loader from '../components/Loader';
import PageWrapper from '../components/PageWrapper';
import { UserPlan } from '../utils/plans';
import { ROUTES } from './routes';
interface PrivateRouteParams extends RouteProps {
    component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
    requiredPlan?: UserPlan[];
    currentPlan?: UserPlan;
}

export function PrivateRoute({ component: Component, requiredPlan, currentPlan, ...rest }: PrivateRouteParams) {
    const { initialized, keycloak } = useKeycloak();
    const hasRequiredPlan = !requiredPlan || !currentPlan || (requiredPlan || []).includes(currentPlan);

    return (
        <Route
            {...rest}
            render={props =>
                !initialized ? (
                    <PageWrapper>
                        <Loader full />
                    </PageWrapper>
                ) : !hasRequiredPlan ? (
                    <Redirect
                        to={{
                            pathname: ROUTES.DASHBOARD,
                            state: {
                                from: props.location,
                                upgrade: true,
                                upgradePlan: requiredPlan?.length === 1 ? requiredPlan[0] : undefined,
                            },
                        }}
                    />
                ) : keycloak?.authenticated ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
}
